export const ensureValidMUIColor = (color: string | undefined | null) => {
  return color && /^#[0-9a-fA-F]{3,6}$/.test(color) ? color : undefined;
};
